import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import api from '../../utils/api';
import { toast } from 'sonner';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Textarea } from '../../components/ui/textarea';
import { Label } from '../../components/ui/label';
import { Switch } from '../../components/ui/switch';

const InternshipSettings = () => {
  const [settings, setSettings] = useState(null);
  const [formData, setFormData] = useState({
    enabled: false,
    title: '',
    description: '',
  });

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await api.get('/internship/settings');
      setSettings(response.data);
      setFormData({
        enabled: response.data.enabled,
        title: response.data.title,
        description: response.data.description,
      });
    } catch (error) {
      toast.error('Failed to load settings');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.put('/internship/settings', formData);
      toast.success('Settings updated');
      fetchSettings();
    } catch (error) {
      toast.error('Failed to update settings');
    }
  };

  if (!settings) {
    return <div className="flex items-center justify-center min-h-screen">Loading...</div>;
  }

  return (
    <div className="min-h-screen bg-slate-50">
      <nav className="bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center space-x-4">
            <Link to="/admin"><ArrowLeft className="w-5 h-5" /></Link>
            <h1 className="text-2xl font-heading font-bold">Internship Settings</h1>
          </div>
        </div>
      </nav>

      <div className="max-w-3xl mx-auto px-6 py-8">
        <div className="bg-white rounded-xl p-8 shadow-sm">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="flex items-center space-x-3">
              <Switch
                checked={formData.enabled}
                onCheckedChange={(checked) => setFormData({...formData, enabled: checked})}
                data-testid="internship-enabled-switch"
              />
              <Label className="text-lg">Enable Internships Page</Label>
            </div>

            <div>
              <Label>Page Title</Label>
              <Input
                value={formData.title}
                onChange={(e) => setFormData({...formData, title: e.target.value})}
                placeholder="e.g., Project-Based Internships"
              />
            </div>

            <div>
              <Label>Page Description</Label>
              <Textarea
                rows={4}
                value={formData.description}
                onChange={(e) => setFormData({...formData, description: e.target.value})}
                placeholder="Describe your internship program"
              />
            </div>

            <Button type="submit" className="w-full bg-primary" data-testid="save-settings-button">
              Save Settings
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default InternshipSettings;
